module.exports={
    logout  : "Konto stornieren",
    my      :'mein',
    scqx    :'Löschen von Berechtigungen',
    qxgl    :'Verwaltung der Behörde',
    qdzxzhm :'Sind Sie sicher, das Konto zu stornieren?',
    qtxkh   :'Bitte geben Sie die Kartennummer ein',
    qd      :'Bestimmen',
    qx      :'Stornieren',
    gb      :'schließen',
    kh      :'Nummer der Karte',
    kmewm   :'Türöffnung QR-Code',
    dl      :'Melden Sie sich',
    name    :'Name des Benutzers',
    qtxname :'Bitte geben Sie den Benutzernamen ein',
    pwas    :'Passwort',
    qtxpwas :'Bitte geben Sie das Passwort ein',
    tj      :'Senden',
    zczh    :'Registriertes Konto',
    zc      :'Register',
    sjhm    :'Telefon Nummer',
    qtxsjhm :'Bitte geben Sie Ihre Mobiltelefonnummer ein',
    yzm     :'Code der Überprüfung',
    qtxyzm  :'Bitte geben Sie den Verifizierungscode ein',
    yyzhqqdl:'Sie haben bereits ein Konto. Gehen Sie und loggen Sie sich ein',
    hqyzm   :'Verifikationscode erhalten',
    zccg    :'Anmeldung erfolgreich',
    zcsb    :'Anmelden fehlgeschlagen',
    fscg    :'Gesendet erfolgreich',
    fssb    :'scheitern in senden',
    yhycz   :'Der Benutzer existiert bereits',
	// 设备搜索页面
	sbss:'Gerätesuche',
	kysb:'Verfügbare Geräte',
	ssjg:'Suchergebnis',
	sbtj:'Hinzufügen von Geräten',
	sblx:'Gerätetyp',
	sfwzcj:'Ist es ein Keygen?',
	qxz:'Bitte wählen',
	azwz:'Einbaulage',
	kmzt:'Der Zustand der Tür',
	wifimm:'WiFi Passwort',
}